import { FORMAT_LABELS, FormatSchema, type Format } from '@ugin/shared';
import { useState } from 'react';

import { useDecks } from '@/hooks/useDecks';
import { RecentMatchesWidget } from '@/widgets/recent-matches';

const ALL = 'all';

export function Matches() {
  const [format, setFormat] = useState<Format | typeof ALL>(ALL);
  const [deckId, setDeckId] = useState<string>(ALL);
  const decks = useDecks();

  return (
    <div className="space-y-6">
      <header className="space-y-1">
        <h1 className="font-display text-4xl tracking-wide text-ugin-text">Matches</h1>
        <p className="text-sm text-ugin-text-muted">
          Every game Arena handed over, with what the opponent showed and when.
        </p>
      </header>

      <div className="flex flex-wrap gap-3">
        <Filter
          label="Format"
          value={format}
          onChange={(v) => { setFormat(v === ALL ? ALL : (v as Format)); }}
          options={[
            { value: ALL, label: 'All formats' },
            ...FormatSchema.options.map((f) => ({ value: f, label: FORMAT_LABELS[f] })),
          ]}
        />
        <Filter
          label="Deck"
          value={deckId}
          onChange={setDeckId}
          options={[
            { value: ALL, label: 'All decks' },
            ...(decks.data?.decks ?? []).map((d) => ({ value: d.id, label: d.name })),
          ]}
        />
      </div>

      <RecentMatchesWidget
        {...(format === ALL ? {} : { format })}
        {...(deckId === ALL ? {} : { deckId })}
        limit={200}
      />
    </div>
  );
}

function Filter({
  label,
  value,
  onChange,
  options,
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: { value: string; label: string }[];
}) {
  return (
    <label className="flex flex-col gap-1 text-xs text-ugin-text-muted">
      {label}
      <select
        value={value}
        onChange={(e) => { onChange(e.target.value); }}
        className="min-w-44 rounded-lg border border-ugin-border bg-ugin-surface px-3 py-2 text-sm text-ugin-text outline-none focus-visible:ring-2 focus-visible:ring-ugin-accent"
      >
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </label>
  );
}
